import { Container, Box, CircularProgress, Typography } from '@mui/material';

/**
 * Loading screen estándar — usado mientras un componente trae sus datos.
 * Si pasás `mensaje`, se muestra debajo del spinner.
 * Si pasás `inline`, omite el Container y queda solo el Box centrado (útil
 * para usar adentro de cards/dialogs donde no querés el full-height).
 */
function Cargando({ mensaje, inline = false, size = 60 }) {
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        height: inline ? 'auto' : '60vh',
        py: inline ? 4 : 0,
      }}
    >
      <CircularProgress size={size} />
      {mensaje && (
        <Typography variant="body2" color="text.secondary">
          {mensaje}
        </Typography>
      )}
    </Box>
  );

  if (inline) return content;

  return <Container maxWidth="xl">{content}</Container>;
}

export default Cargando;
